import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ScorecardMetricGoalModerateDto,
  Scorecard,
  ScorecardsActionStoreArgument,
} from 'store/interfaces';
import api from 'api';
import { API_SCORECARD_METRIC_MODERATE } from 'constants/api';
import { generateURL } from 'helpers';
import { updateFullData } from './updateFullData';

export const moderateMetric = createAsyncThunk<
  Scorecard,
  {
    id: number;
    data: ScorecardMetricGoalModerateDto;
    store: ScorecardsActionStoreArgument;
  }
>('scorecards/moderateMetric', async ({ id, data, store }, thunkAPI) =>
  api.axios
    .patch<Scorecard>(generateURL(API_SCORECARD_METRIC_MODERATE, { id }), data)
    .then((res) => {
      thunkAPI.dispatch(updateFullData({ id, store }));
      return res.data;
    })
    .catch((e) => thunkAPI.rejectWithValue(e.response?.data)),
);
